import type {
  CompanyPendingChangesPayload,
  CompanyReportPayload,
  SegmentAnalysisRunMode,
  SegmentAnalysisRunPayload,
  SegmentCompany,
} from "../types"

import { api } from "@/lib/api-client"

export function listSegmentCompanies(
  segmentId: string,
  options: { includeSummaries?: boolean } = {}
): Promise<{ segmentId: string; companies: SegmentCompany[] }> {
  // Summaries cost a plan read per company server-side, so only the Customers
  // tab asks for them — drill-down callers just need the name→id map.
  const query = options.includeSummaries ? "?includeSummaries=1" : ""
  return api.get<never, { segmentId: string; companies: SegmentCompany[] }>(
    `/segment-analysis/segments/${segmentId}/companies${query}`
  )
}

export function startCompanyRun(
  companyId: string,
  input: { fromSegmentId?: string; mode: SegmentAnalysisRunMode }
): Promise<SegmentAnalysisRunPayload> {
  return api.post<typeof input, SegmentAnalysisRunPayload>(
    `/segment-analysis/companies/${companyId}/runs`,
    input
  )
}

export function getCompanyRun(
  companyId: string,
  runId: string
): Promise<SegmentAnalysisRunPayload> {
  return api.get<never, SegmentAnalysisRunPayload>(
    `/segment-analysis/companies/${companyId}/runs/${runId}`
  )
}

export function getCompanyReport(companyId: string): Promise<CompanyReportPayload> {
  return api.get<never, CompanyReportPayload>(`/segment-analysis/companies/${companyId}/report`)
}

export function getCompanyPending(companyId: string): Promise<CompanyPendingChangesPayload> {
  return api.get<never, CompanyPendingChangesPayload>(
    `/segment-analysis/companies/${companyId}/pending`
  )
}

export function decideCompanyChanges(
  companyId: string,
  input: { decision: "approve" | "reject"; changeId?: string }
): Promise<{ subjectId: string; approved: string[]; rejected: string[]; remaining: number }> {
  return api.post(`/segment-analysis/companies/${companyId}/decision`, input)
}
